export default [
    // packages ordered by priority
    "PFPF",
    "PFF",
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFPTTF",
    "PFTTF",
    "HS",
    "PF",
    "PFP",

];
